import { LazyRoute } from "@appretio/shared";
import { ErrorBoundary, semanticThemeTokens } from "@appretio/ui-kit";
import { lazy } from "react";
import { Outlet, type RouteObject } from "react-router-dom";

const InspirationPage = lazy(() =>
  import("./inspirationPage/InspirationPage").then((m) => ({
    default: m.InspirationPage
  }))
);

export const designRoutes: RouteObject = {
  path: "design",
  handle: {
    label: "Design",
    background: semanticThemeTokens.backgroundGradient[4]
  },
  element: <Outlet />,
  children: [
    {
      path: "inspiration",
      handle: { label: "Inspiration" },
      element: (
        <ErrorBoundary level="route">
          <LazyRoute>
            <InspirationPage />
          </LazyRoute>
        </ErrorBoundary>
      )
    }
  ]
};
